import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

export async function storeToken(token: string) {
  if (Capacitor.isNativePlatform()) {
    await Preferences.set({ key: 'token', value: token });
  } else {
    localStorage.setItem('token', JSON.stringify(token));
  }
}

export async function storeRefreshToken(refreshToken: string) {
  if (Capacitor.isNativePlatform()) {
    await Preferences.set({ key: 'refreshToken', value: refreshToken });
  } else {
    localStorage.setItem('refreshToken', JSON.stringify(refreshToken));
  }
}

export async function getToken(): Promise<string | null> {
  if (Capacitor.isNativePlatform()) {
    const { value } = await Preferences.get({ key: 'token' });
    return value ?? null;
  } else {
    return JSON.parse(localStorage.getItem('token') || 'null');
  }
}

export async function getRefreshToken(): Promise<string | null> {
  if (Capacitor.isNativePlatform()) {
    const { value } = await Preferences.get({ key: 'refreshToken' });
    return value ?? null;
  } else {
    return JSON.parse(localStorage.getItem('refreshToken') || 'null');
  }
}

export function getJwtPayload(token: string): any | null {
  try {
    const payloadBase64 = token.split('.')[1];
    const decodedPayload = JSON.parse(atob(payloadBase64));
    return decodedPayload;
  } catch (error) {
    return null;
  }
}

export function isTokenExpired(token: string): boolean {
  const payload = getJwtPayload(token);
  if (!payload?.exp) return true;

  const now = Math.floor(Date.now() / 1000); // timestamp en secondes
  return now >= payload.exp;
}

export async function clearTokens() {
  if (Capacitor.isNativePlatform()) {
    await Preferences.remove({ key: 'token' });
    await Preferences.remove({ key: 'refreshToken' });
  } else {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
  }
}
